// Interfaces
export interface ActiveChestData{
    amount : number
    flatIcon : string
    rewardList : any[]
    copyLink : string
    userCount : number
    activityIntro : any[]
}

export interface PlayListItem {
    uid: number,
    createTime: string,
    rewardAmount: number,
    claimStatus: number
}

export interface ChestUserData {
    playersList: PlayListItem[]
    total : number
    pageSize : number
    pageNum : number
}


// Constant
export const SHARE_LIST = ([
    { img: require('@/assets/sideNavbar/facebook_cai.png'), name: 'Facebook' },
    { img: require('@/assets/sideNavbar/Whatsapp_cai.png'), name: 'Whatsapp' },
    { img: require('@/assets/sideNavbar/Telegram_cai.png'), name: 'Telegram' },
    { img: require('@/assets/sideNavbar/insgram_cai.png'), name: 'Instagram' },
    { img: require('@/assets/sideNavbar/twitter_cai.png'), name: 'Twitter' },
    { img: require('@/assets/sideNavbar/kwai_cai.png'), name: 'Kwai' }
])

export const PAGE_SIZE = 20

export const TAB_LIST = ([{ name: 'message.all' },
{ name: 'activityStatus.active' },
{ name: 'activityStatus.inactive' },
{ name: 'activityStatus.pending' }])

// Functions